import React from 'react';
import { ContractIdentifierWithName } from './contract-identifier-with-name';
import {
  DefaultContractIdentifier,
  UnknownContractInfo,
} from './default-contract-identifier';
import { DeployContractPackageResult } from '@block-explorer/entities';
import { HashLength } from '@make-software/cspr-ui';
import { AvatarProps } from '../avatar/avatar';
import { HashFontSize } from '../table-data-account-info/table-data-account-info';
import { useGetContractPackageInfo } from '../../hooks/event-store-hooks';

interface ContractIdentifierProps {
  hash: string;
  withName?: boolean;
  contractPackage?: DeployContractPackageResult;
  hideContractType?: boolean;
  hashLength?: HashLength;
  avatarSize?: AvatarProps['size'];
  hashFontSize?: HashFontSize;
  loading?: boolean;
}

export const ContractIdentifier = ({
  withName = false,
  ...props
}: ContractIdentifierProps) => {
  const { data: contractPackageInfo } = useGetContractPackageInfo(
    !props.contractPackage && props.hash
      ? {
          contract_package_hash: props.hash,
        }
      : null
  );

  const contactPackageData = props.contractPackage || contractPackageInfo?.data;

  if (!contactPackageData) {
    return (
      <UnknownContractInfo
        hash={props.hash}
        iconSize={props.avatarSize}
        hashFontSize={props.hashFontSize}
        hashLength={props.hashLength}
        avatarSize={props.avatarSize}
      />
    );
  }

  if (withName) {
    return (
      <ContractIdentifierWithName
        {...props}
        contractPackage={contactPackageData}
      />
    );
  }

  return (
    <DefaultContractIdentifier
      {...props}
      contractPackage={contactPackageData}
    />
  );
};
